import React from 'react'

import ProductsOverview from '../../../react4xp/components/ProductsOverview'

function ProductsOverviewPart({title, endpoint, categories, additionalPackaging, startValues, strings}) {
    return (
        <ProductsOverview
            title={title}
            endpoint={endpoint}
            categories={categories}
            additionalPackaging={additionalPackaging}
            startValues={startValues}
            strings={strings}
        />
    )
}

export default (props) => <ProductsOverviewPart {...props} />
